// @flow

import * as React from "react";

import SectionHeader from "./SectionHeader";
import Image from "../atoms/Image";
import LinkHandler from "../atoms/LinkHandler";

type PropsType = {
    icons: any[],
    target?: string,
    title: string,
};

const Sponsors = (props: PropsType): React.Node => {
    const target = props.target ? props.target : "_self";
    return (
        <div className="icon-row">
            <SectionHeader
                sectionName="icon-row"
                title={props.title}
                description={props.description}
            />
            <div className="row">
                {props.icons.map((icon, tileIndex): React.Node => {
                    return (
                        <LinkHandler
                            to={icon.link}
                            key={tileIndex}
                            className="col-xs-6 col-md-3 icon-row__icon"
                            target={target}
                        >
                            <div className="icon-row__icon__image">
                                <Image
                                    src={icon.icon.url}
                                    alt={icon.icon.title}
                                    aspectRatio="1:1"
                                />
                            </div>
                        </LinkHandler>
                    );
                })}
            </div>
        </div>
    );
};

Sponsors.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

export default Sponsors;
